import React from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';

const Container = styled.div`
  height: 80vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const SimpleCircularProgress = () => (
  <Container>
    <CircularProgress />
  </Container>
);

export default SimpleCircularProgress;
